module.exports = __webpack_public_path__ + "static/media/favicon.dcd412ee.png";